module.exports = __webpack_public_path__ + "img/liebao-logo.0b6f640c.png";